<template lang="pug">
div.details
	span(v-if="content.surtitle != ''") {{content.surtitle}}
	h1 {{content.headline}}
	div(v-if="content.copy != ''" v-html="content.copy")
</template>

<script>
export default {
	name: 'Details',
	props: ['content']
}
</script>



// WEBPACK FOOTER //
// src/components/features/Details/index.vue